import type { MouseEvent } from 'react'

import { ActionsStore, useAnchorClass as useAnchor } from 'shared/position'

import css from './QuickActions.module.scss'

const store = new ActionsStore<HTMLButtonElement>({
	getValue: button => button?.value ?? ''
})

const useAnchorClass = (id: string) =>
	useAnchor({ anchorClassName: css.currentAnchor, id, store })

const openActions = (event: MouseEvent<HTMLButtonElement>) => {
	const button = event.currentTarget
	store.toggleTrigger(button)
}

export { openActions, store, useAnchorClass }
